import { useEffect } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { UserAuth } from '@/utils/enum'
import HeaderBar from './header-bar'
import Message from './message'
import { LANDING_VERSION } from '@/pages/landing/version'
import NoxFooter from '@/pages/landing/nox/footer'

const isNox = LANDING_VERSION === 'nox'

const Wrapper = styled.div<{ isLogin: boolean, isLandingPage: boolean, fluid: boolean }>`
  width: 100%;
  min-width: ${ props => props.isLogin && !props.isLandingPage && !props.fluid ? '1288px' : null };
  background-color: ${ props => props.isLandingPage ? props.theme.palette.white : props.theme.palette.greyBG };
`

const Main = styled.main<{ isLogin: boolean, email: boolean, isLandingPage: boolean, hideHeader: boolean, fluid: boolean }>`
  margin: 0 auto;
  padding-top: ${props => props.hideHeader ? '0' : ((props.isLogin && props.email) || props.isLandingPage ? '64px' : '0')};
  width: ${ props => (props.isLogin && props.email  && !props.isLandingPage && !props.fluid)  ? '1080px' : '100%' };
  max-width: ${ props => props.fluid ? '1080px' : 'none' };
  min-height: 100vh;
`

const Layout = (props: any) => {
  const location =  useLocation()
  useEffect(() => window.scrollTo(0, 0), [location])

  const isLogin = useSelector((state: RootState) => state.auth !== UserAuth.GUEST)
  const email = useSelector((state: RootState) => state.userInfo.email)
  const isLandingPage = location.pathname === '/'
  // The signal AI-check report is a self-contained, fully responsive page, so
  // opt it out of the desktop-only fixed-width shell (min-width 1288 / 1080px
  // Main) — otherwise the iframe is forced to a desktop width and breaks on mobile.
  const isFluid = /\/ai-check$/.test(location.pathname)
  // nox 版 landing 自帶 nav，隱藏全站 HeaderBar 與頂邊距
  const hideGlobalHeader = isLandingPage && isNox

  return (
    <Wrapper isLogin={isLogin} isLandingPage={isLandingPage} fluid={isFluid}>
      {!hideGlobalHeader && !isLogin && <HeaderBar/> }

      {!hideGlobalHeader && isLogin && Boolean(email) &&
        <HeaderBar/>
      }

      <Main isLogin={isLogin} email={Boolean(email)} isLandingPage={isLandingPage} hideHeader={hideGlobalHeader} fluid={isFluid}>
        {props.children}
      </Main>

      {/* nox 版：全站統一在底部 render NOX footer（landing 的 footer 由此提供，不再於 landing 內部重複 render） */}
      {isNox && <NoxFooter/>}

      <Message />
    </Wrapper>
  )
}

export default Layout
